(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("deviationTypeService", ['$ihttp', function ($ihttp) {
        let service = {
            getDeviationType: function (parms) {
                return $ihttp.post({
                    method: 1229,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1230,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
